var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-footer',{staticClass:"pa-0 ma-0"},[_c('v-card',{staticClass:"blue-grey darken-2 text-center",attrs:{"flat":"","tile":"","width":"100%"}},[_c('v-card-text'),_c('v-divider'),_c('v-card-text',{staticClass:"white--text"},[_vm._v(" "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v("reitoumikan")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }